/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });
    
    // wait until images fully loaded THEN resize
    $slideshowClassicEl.find('img').each(function () {
      if (this.complete) {
        $slideshowClassicEl.flickity('resize');
      } else {
        $(this).one('load', function () {
          $slideshowClassicEl.flickity('resize');
        });
      }
    });

    // Fix video height issue
    $slideshowClassicEl.find('video').each(function () {
      var vid = this;

      if (vid.readyState >= 1) {
        $slideshowClassicEl.flickity('resize');
      } else {
        vid.addEventListener('loadedmetadata', function () {
          $slideshowClassicEl.flickity('resize');
        });

        vid.addEventListener('loadeddata', function () {
          $slideshowClassicEl.flickity('resize');
        });
      }
    });

    // Final backup resize
    setTimeout(function(){
      $slideshowClassicEl.flickity('resize');
    }, 100);

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;